<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Calendar</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="row">
				<div class="col-md-12">
					<div class="card card-primary card-outline">
						<div class="card-body">
							<div class="col-sm-6">
    						<div class="card">
      						<div class="card-body">
        						 <FullCalendar :options="calendarOptions" />
      						</div>
    						</div>
  						</div>
						</div>
					</div>
				</div>




			</div>
		</section>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>

			

		import FullCalendar from '@fullcalendar/vue'
		import dayGridPlugin from '@fullcalendar/daygrid'
		import timeGridPlugin from '@fullcalendar/timegrid'
		import interactionPlugin from '@fullcalendar/interaction'
    export default {
    		components: {
    			FullCalendar
    		},
    		
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getUpcomingJobs();
        },
        
        data(){
        	return {
        		calendarOptions: {
        			plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        			headerToolbar: {
          			left: 'prev,next today',
          			center: 'title',
         	 			right: 'dayGridMonth,timeGridWeek,timeGridDay'
        			},
        			events: [],
        			initialView: 'dayGridMonth'
        		}
        	}
        },
        
        methods: {
        	getUpcomingJobs(){
        		axios.post("/api/getUpcomingJobs", {id: this.$userId})
        		.then(response => {
        			for(var res in response.data)
        				this.calendarOptions.events.push(response.data[res]);
        		})
        	}
        }
    }
</script>
